/*eslint-disable */
import React, { useEffect, useRef, useState } from "react";
import { Helmet } from "react-helmet-async";
import { getResponsiveImage, getSrcSet } from "../utils/imageHelper";
import axios from "axios";
import * as XLSX from "xlsx";
import MenuLayouts from "../layouts/menu.layout";
import FooterLayouts from "../layouts/footer.layout";
import MenuVehiculosDetailComponent from "../components/vehiculos-detail/menu-vehiculos.component";
import BannerVehiculosComponent from "../components/vehiculos-detail/banner-vehiculos.component";
import DiseñoVehiculosComponent from "../components/vehiculos-detail/diseño-vehiculos.component";
import ModelosVehiculosComponent from "../components/vehiculos-detail/modelos-vehiculos.component";
import GaleriaVehiculosComponent from "../components/vehiculos-detail/galeria-vehiculos.component";
import GaleriaModalVehiculosComponent from "../components/vehiculos-detail/galeriaModal-vehiculos.component";
import CaracteristicasVehiculosComponent from "../components/vehiculos-detail/caracteristicas-vehiculos.component";
import TecnologiaVehiculosComponent from "../components/vehiculos-detail/tecnologia-vehiculos.component";
import VersionesVehiculosComponent from "../components/vehiculos-detail/versiones-vehiculos.component";
import ReservaVehiculosComponent from "../components/vehiculos-detail/reserva-vehiculos.component";
import ComunidadVehiculosComponent from "../components/vehiculos-detail/comunidad-vehiculos.component";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import CotizacionVehiculosComponent from "../components/vehiculos-detail/cotizacion-vehiculos.component";
import { VehiclesOnly } from "../components/conexion/vehicles.conexion";
import BtnFloatingLayout from "../layouts/btn_flotante.layout";
import HICSVehiculosComponent from "../components/vehiculos-detail/hics-vehiculos.component";
import OtrosVehiculosDinamicoComponent from "../components/vehiculos-detail/otros-vehiculos-dinamico.component";
import TitleComponent from "../components/posventa/comparador/title.component";
import SeleccionComponent from "../components/posventa/comparador/seleccion.component";
import AcordeonComponent from "../components/posventa/comparador/acordeon.component";
import ModalComunidadHyundaiComponent from "../components/home/modal_comunidad_hyundai.component";
import ContenidoComunidadHyundaiComponent from "../components/home/contenido_comunidad_hyundai.component";
import MotorVehiculosComponent from "../components/vehiculos-detail/motor-vehiculos.component";
declare const window: any;

const dataVehicles: any = [
  /* {
    name: "CRETA",
    slug: "creta",
    nameFromAPI: "CRETA",
    version: "PREMIUM",
  }, */
  {
    name: "Grand Metro Taxi Hatchback",
    slug: "grand-metro-taxi-hatchback",
    nameFromAPI: "GRAND METRO HATCHBACK",
    version: "HATCHBACK",
  },
  {
    name: "Grand Metro Taxi Sedán",
    slug: "grand-metro-taxi-sedan",
    nameFromAPI: "GRAND METRO SEDÁN",
    version: "SEDÁN",
  },
  {
    name: "GRAND i10 MT Attraction",
    slug: "grand-i10",
    nameFromAPI: "GRAND i10",
    version: "MT Attraction",
  },
  {
    name: "GRAND i10 AT Premium",
    slug: "grand-i10",
    nameFromAPI: "GRAND i10",
    version: "AT Premium",
  },
  {
    name: "HB20 Advance",
    slug: "hb20-hatchback",
    nameFromAPI: "HB20 Hatchback",
    version: "ADVANCE MT",
  },
  {
    name: "HB20 Premium",
    slug: "hb20-hatchback",
    nameFromAPI: "HB20 Hatchback",
    version: "PREMIUM AT",
  },
  {
    name: "HB20S Premium",
    slug: "hb20s-sedan",
    nameFromAPI: "HB20S Sedán",
    version: "PREMIUM AT",
  },
  {
    name: "HB20S Advance",
    slug: "hb20s-sedan",
    nameFromAPI: "HB20 Sedán",
    version: "ADVANCE MT",
  },
  /* {
    name: "IONIQ 5",
    slug: "ioniq-5",
    nameFromAPI: "IONIQ 5",
    version: "EV-Power",
  }, */
  {
    name: "KONA Gasolina Attraction",
    slug: "kona-gasolina",
    nameFromAPI: "KONA Gasolina",
    version: "Attraction",
  },
  {
    name: "KONA Gasolina Premium",
    slug: "kona-gasolina",
    nameFromAPI: "KONA Gasolina",
    version: "Premium",
  },
  {
    name: "KONA Gasolina Limited",
    slug: "kona-gasolina",
    nameFromAPI: "KONA Gasolina",
    version: "Limited",
  },
  {
    name: "KONA Híbrida Attraction",
    slug: "kona-hibrida",
    nameFromAPI: "KONA Híbrida",
    version: "Attraction",
  },
  {
    name: "KONA Híbrida Premium",
    slug: "kona-hibrida",
    nameFromAPI: "KONA Híbrida",
    version: "Premium",
  },
  {
    name: "KONA Híbrida Limited",
    slug: "kona-hibrida",
    nameFromAPI: "KONA Híbrida",
    version: "Limited",
  },
  {
    name: "KONA Híbrida N Line",
    slug: "kona-n-line",
    nameFromAPI: "KONA N Line",
    version: "N Line AT",
  },
  {
    name: "KONA Eléctrica Limited",
    slug: "kona-electrica",
    nameFromAPI: "KONA Eléctrica",
    version: "Limited",
  },
  /* {
    name: "PALISADE",
    slug: "palisade",
    nameFromAPI: "PALISADE",
    version: "Palisade sport 4x4 AT",
  }, */
  {
    name: "SANTA FE Híbrida Premium",
    slug: "santa-fe-hibrida",
    nameFromAPI: "SANTA FE",
    version: "Premium",
  },
  {
    name: "SANTA FE Híbrida Limited",
    slug: "santa-fe-hibrida",
    nameFromAPI: "SANTA FE",
    version: "Limited 4x4",
  },
  {
    name: "STARIA PASAJEROS",
    slug: "staria-pasajeros",
    nameFromAPI: "STARIA Pasajeros",
    version: "Diésel",
  },
  {
    name: "STARIA PANEL",
    slug: "staria-panel",
    nameFromAPI: "STARIA Panel",
    version: "Diésel",
  },
  {
    name: "TUCSON Híbrida XL Limited 4X4",
    slug: "tucson-hibrida",
    nameFromAPI: "TUCSON",
    version: "AT Limited 4x4",
  },
  {
    name: "TUCSON Híbrida XL Premium",
    slug: "tucson-hibrida",
    nameFromAPI: "TUCSON",
    version: "AT Premium 4x2",
  },
  {
    name: "TUCSON Híbrida XL Limited",
    slug: "tucson-hibrida",
    nameFromAPI: "TUCSON",
    version: "AT Limited 4x2",
  },
  {
    name: "TUCSON Gasolina XL Attraction MT",
    slug: "tucson",
    nameFromAPI: "TUCSON",
    version: "Attraction MT",
  },
  /* {
    name: "TUCSON Attraction AT",
    slug: "tucson",
    nameFromAPI: "TUCSON",
    version: "Attraction AT",
  }, */
  {
    name: "TUCSON Gasolina XL Premium",
    slug: "tucson",
    nameFromAPI: "TUCSON",
    version: "Premium",
  },
  {
    name: "TUCSON Gasolina XL Limited",
    slug: "tucson",
    nameFromAPI: "TUCSON",
    version: "Limited",
  },
  {
    name: "VENUE Limited AT",
    slug: "venue",
    nameFromAPI: "VENUE",
    version: "Limited AT",
  },
  {
    name: "VENUE Premium MT",
    slug: "venue",
    nameFromAPI: "VENUE",
    version: "Premium MT",
  },
];

const grupos: any = [
  "Powertrain",
  "Safety",
  "Lights",
  "Tyre and Wheels",
  "Exterior",
  "Interior",
  "Seats",
  "ADAS",
  "Climate Control",
  "Infotainment & Connectivity",
  "Convenience",
  "Dimensions",
];

// Definir una interfaz para el vehículo procesado
interface VehicleData {
  name: string;
  [key: string]: boolean | string | undefined; // Claves dinámicas para otras propiedades
}

/* const comunidad: any = [
  "../assets/comunidad_hyundai/comunidad_2.webp",
  "../assets/comunidad_hyundai/comunidad_4.webp",
  "../assets/comunidad_hyundai/comunidad_1.webp",
  "../assets/comunidad_hyundai/comunidad_3.webp",
]; */

const VehiculosDetailPage: React.FC = () => {
  const motorRef = useRef<HTMLDivElement>(null);
  const cotizacionRef = useRef<HTMLDivElement>(null);
  const diseñoRef = useRef<HTMLDivElement>(null);
  const versionesRef = useRef<HTMLDivElement>(null);
  const galeriaRef = useRef<HTMLDivElement>(null);
  const tecnologiaRef = useRef<HTMLDivElement>(null);
  const modelosRef = useRef<HTMLDivElement>(null);
  const [isModalOpen, setModalOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const handleOpenModal = () => {
    setModalOpen(true);
    document.documentElement.style.overflowY = "hidden"; // Establece overflow-y en <html>
  };

  const handleCloseModal = () => {
    setModalOpen(false);
    document.documentElement.style.overflowY = "auto"; // Restablece overflow-y en <html>
  };

  const { vehiculo }: any = useParams();
  const { section } = useParams();
  const [selectedGalery, setSelectedGalery] = useState(null);
  const [selectedMenu, setSelectedMenu] = useState("");
  const [dataVehiculos, setDataVehiculos] = useState([]);
  const [loading, setLoading] = useState(true); // Nuevo estado de carga
  const [visibleHICS, setVisibleHICS] = useState(false); // Nuevo estado de carga
  const [banner, setBanner] = useState({});
  const [vehiculos, setVehiculos] = useState({});
  const [diseño, setDiseño] = useState({});
  const [modelos, setModelos]: any = useState({});
  const [engine, setEngine]: any = useState({});
  const [comparador, setComparador]: any = useState({});
  const [galeria, setGaleria]: any = useState({});
  const [reserva, setReserva]: any = useState("");
  const [urlComparador, setUrlComparador]: any = useState(null);
  const [opportunities, setOpportunities]: any = useState("");
  const [caracteristicas, setCaracteristicas] = useState({});
  const [tecnologias, setTecnologias]: any = useState({});
  const [versiones, setVersiones]: any = useState({});
  const [HICS, setHICS]: any = useState("");
  const [fichaTecnica, setFichaTecnica]: any = useState("");
  const [brochures, setBrochures] = useState<any>([]);
  const [visibleHeight, setVisibleHeight] = useState(0);
  const [currentSection, setCurrentSection] = useState<string>("");
  const [data, setData] = useState<VehicleData[]>([]);
  const [comunidad, setComunidad] = useState([]);
  const [firtsVehicle, setFirtsVehicle] = useState([]);
  const [secondVehicle, setSecondVehicle] = useState([]);
  const [activeComparador, setActiveComparador] = useState(false);
  const [utmParams, setUTMParams] = useState({});
  const [ipAddress, setIPAddress] = useState("");
  const [topbar_design, set_topbar_design] = useState("");
  const [topbar_gallery, set_topbar_gallery] = useState("");
  const [topbar_models, set_topbar_models] = useState("");
  const [topbar_technology, set_topbar_technology] = useState("");
  const [topbar_version, set_topbar_version] = useState("");
  const [modelos2, setModelos2] = useState([
    {
      nombremodelo: "IONIQ 5 EV",
      nombrefamilia: "IONIQ 5",
      internal: "IONIQ 5",
      idmodelo: "a1YQC000000FK4s2AG",
      idfamilia: "a1FQC000007vHGE2A2",
    },
    {
      nombremodelo: "TUCSON 2.0L",
      nombrefamilia: "TUCSON",
      internal: "TUCSON",
      idmodelo: "a1YQC000000FL4A2AW",
      idfamilia: "a1FQC000007vHWM2A2",
    },
    {
      nombremodelo: "TUCSON 1.6T HEV",
      nombrefamilia: "TUCSON HIBRIDA",
      internal: "TUCSON Híbrida",
      idmodelo: "a1YQC000001AXN72AO",
      idfamilia: "a1FQC00000U0pFl2AJ",
    },
    {
      nombremodelo: "GRAND I10 1.2L",
      nombrefamilia: "Grand i10",
      internal: "GRAND METRO SEDÁN",
      idmodelo: "a1YQC000000FKT42AO",
      idfamilia: "a1FQC000007vHco2AE",
    },
    {
      nombremodelo: "GRAND I10",
      nombrefamilia: "Grand i10",
      internal: "Grand i10",
      idmodelo: "a1YQC000003IjZd2AK",
      idfamilia: "a1FQC000007vHco2AE",
    },
    {
      nombremodelo: "GRAND I10 HB 1.2L",
      nombrefamilia: "Grand i10",
      internal: "GRAND METRO HATCHBACK",
      idmodelo: "a1YQC0000010Fhd2AE",
      idfamilia: "a1FQC000007vHco2AE",
    },
    {
      nombremodelo: "CRETA 1.5L",
      nombrefamilia: "CRETA",
      internal: "CRETA",
      idmodelo: "a1YQC000000FLTx2AO",
      idfamilia: "a1FQC000007vHuX2AU",
    },
    {
      nombremodelo: "HB20 1.6L",
      nombrefamilia: "HB20",
      internal: "HB20 Hatchback",
      idmodelo: "a1YQC000000FKrG2AW",
      idfamilia: "a1FQC000007vI7R2AU",
    },
    {
      nombremodelo: "HB20S 1.6L",
      nombrefamilia: "HB20S",
      internal: "HB20S Sedán",
      idmodelo: "a1YQC000000FLIf2AO",
      idfamilia: "a1FQC000007vI932AE",
    },
    {
      nombremodelo: "KONA 2.0L",
      nombrefamilia: "KONA",
      internal: "KONA Gasolina",
      idmodelo: "a1YQC000000FLtl2AG",
      idfamilia: "a1FQC000007vIAf2AM",
    },
    {
      nombremodelo: "KONA 1.6L HEV",
      nombrefamilia: "KONA",
      internal: "KONA Híbrida",
      idmodelo: "a1YQC000000FLvN2AW",
      idfamilia: "a1FQC000007vIAf2AM",
    },
    {
      nombremodelo: "KONA EV",
      nombrefamilia: "KONA",
      internal: "KONA Eléctrica",
      idmodelo: "a1YQC000000FM6f2AG",
      idfamilia: "a1FQC000007vIAf2AM",
    },
    {
      nombremodelo: "KONA 1.6L HEV",
      nombrefamilia: "KONA",
      internal: "KONA Híbrida N Line",
      idmodelo: "a1YQC000000eQyH2AU",
      idfamilia: "a1FQC000007vIAf2AM",
    },
    {
      nombremodelo: "PALISADE 3.5L",
      nombrefamilia: "PALISADE",
      internal: "PALISADE",
      idmodelo: "a1YQC000000FM9t2AG",
      idfamilia: "a1FQC000007vIH72AM",
    },
    {
      nombremodelo: "STARIA 2.2L DIESEL",
      nombrefamilia: "STARIA",
      internal: "STARIA panel",
      idmodelo: "a1YQC000000FK9i2AG",
      idfamilia: "a1FQC000007vIIj2AM",
    },
    {
      nombremodelo: "STARIA 3.5L",
      nombrefamilia: "STARIA",
      internal: "STARIA lujo",
      idmodelo: "a1YQC000000FMD72AO",
      idfamilia: "a1FQC000007vIIj2AM",
    },
    {
      nombremodelo: "STARIA 2.2L DIESEL",
      nombrefamilia: "STARIA",
      internal: "STARIA pasajeros",
      idmodelo: "a1YQC000000FMEj2AO",
      idfamilia: "a1FQC000007vIIj2AM",
    },
    {
      nombremodelo: "VENUE 1.6L",
      nombrefamilia: "VENUE",
      internal: "VENUE",
      idmodelo: "a1YQC000000FMhl2AG",
      idfamilia: "a1FQC000007vILx2AM",
    },
    {
      nombremodelo: "SANTA FE 1.6T HEV",
      nombrefamilia: "SANTA FE Híbrida",
      internal: "SANTA FE Híbrida",
      idmodelo: "a1YQC0000011VPN2A2",
      idfamilia: "a1FQC00000PcdoL2AR",
    },
  ]);

  useEffect(() => {
    // Accedemos directamente a la etiqueta body
    const bodyElement = document.body;

    // Añadir la clase deseada a body
    bodyElement.classList.remove("active"); //
    setLoading(true); // Establecer carga en true antes de la llamada
    VehiclesOnly(vehiculo)
      .then(function (res: any) {
        let data: any = res.data.data[0];
        setFichaTecnica(data?.url_brochure);
        setBrochures(data?.brochures || []);
        set_topbar_design(data?.topbar_design);
        set_topbar_gallery(data?.topbar_gallery);
        set_topbar_models(data?.topbar_models);
        set_topbar_technology(data?.topbar_technology);
        set_topbar_version(data?.topbar_version);
        setBanner({
          modelo: vehiculo,
          title: data?.vehicle?.name,
          src: data?.media_banner?.url,
          srcPortrait: data?.media_banner_portrait?.url,
          type: data?.media_banner_type,
          ICSH: data?.url_3d,
          sello: data?.vehicle?.security_seal?.url,
          template: data?.template,
        });
        setVehiculos({
          modelo: vehiculo,
          title: data?.vehicle?.name,
          src: data?.image_reserve?.url,
          precio: data?.vehicle?.price,
          reserva: data?.url_reserva,
        });
        setDiseño({
          modelo: vehiculo,
          title: data?.title_design,
          contenido: data?.design,
        });
        setModelos({
          modelo: vehiculo,
          title: data?.vehicle?.name,
          title_versions: data?.title_versions,
          modelos: data?.versions,
        });
        setEngine({
          modelo: vehiculo,
          engine: data?.engine,
        });
        setGaleria({
          modelo: vehiculo,
          thumbnail: [
            data?.gallery[0]?.thumbnailmedia1?.url,
            data?.gallery[0]?.thumbnailmedia2?.url,
            data?.gallery[0]?.thumbnailmedia3?.url,
            data?.gallery[0]?.thumbnailmedia4?.url,
            data?.gallery[0]?.thumbnailmedia5?.url,
            data?.gallery[0]?.thumbnailmedia6?.url,
            data?.gallery[0]?.thumbnailmedia7?.url,
          ],
          media: [
            data?.gallery[0]?.media1?.url,
            data?.gallery[0]?.media2?.url,
            data?.gallery[0]?.media3?.url,
            data?.gallery[0]?.media4?.url,
            data?.gallery[0]?.media5?.url,
            data?.gallery[0]?.media6?.url,
            data?.gallery[0]?.media7?.url,
          ],
          mediaType: [
            data?.gallery[0]?.media1_type,
            data?.gallery[0]?.media2_type,
            data?.gallery[0]?.media3_type,
            data?.gallery[0]?.media4_type,
            data?.gallery[0]?.media5_type,
            data?.gallery[0]?.media6_type,
            data?.gallery[0]?.media7_type,
          ],
        });
        setCaracteristicas({
          modelo: vehiculo,
          tecnologia: data?.technology_carousel,
        });
        setTecnologias({
          modelo: vehiculo,
          tecnologia: data?.technology_smartsense,
        });
        setReserva(data?.url_reserve);
        setUrlComparador(data?.url_comparator);
        setVersiones({
          modelo: vehiculo,
          version: data?.card_models,
        });
        setOpportunities(
          data?.opportunity1 && data?.opportunity2 && data?.opportunity3
            ? [data?.opportunity1, data?.opportunity2, data?.opportunity3]
            : []
        );
        setComunidad(data?.community_posts);
        setHICS(data?.url_3d);
        setLoading(false); // Establecer carga en false después de la llamada

        /* const dataLayerEvent: any = {
          event: "info_request_view",
          comp_product: {
            vehicle_type: "Car",
            brand: "Hyundai",
            product_condition: null, //vehiculo?.is_new ? "new" : "",
            model: `${
          modelos2?.find(
            (e: any) =>
              e.internal?.trim().toLowerCase() ===
            data?.vehicle?.name?.trim().toLowerCase()
          )?.nombremodelo
        }`,
            version: null,
            fuel_type: null,
            dealer_name: null,
            name_form_sha: null,
            name_form: null,
            phone_form_sha: null,
            phone_form: null,
            email_form_sha: null,
            email_form: null,
            step: null,
          },
        }; */

        /* const dataLayerEvent2: any = {
          event: "info_request_steps",
          comp_product: {
            vehicle_type: "Car",
            brand: "Hyundai",
            product_condition: null, //vehiculo?.is_new ? "new" : "",
            model:
            `${
          modelos2?.find(
            (e: any) =>
              e.internal?.trim().toLowerCase() ===
            data?.vehicle?.name?.trim().toLowerCase()
          )?.nombremodelo
        }`,
            version: null,
            fuel_type: null,
            dealer_name: null,
            name_form_sha: null,
            name_form: null,
            phone_form_sha: null,
            phone_form: null,
            email_form_sha: null,
            email_form: null,
            step: "1/1"
          },
        }; */

        /* // Empujar al dataLayer
        if (window.dataLayer) {
          window.dataLayer.push(dataLayerEvent2);
        }

        // Empujar al dataLayer
        if (window.dataLayer) {
          window.dataLayer.push(dataLayerEvent);
        }
        console.log("aquiii"); */
      })
      .catch((error) => {
        console.log(error);

        setLoading(false); // Manejo de errores
      });
  }, [vehiculo]);

  useEffect(() => {
    setVisibleHICS(false);
  }, []);

  // Agregar y limpiar el evento scroll
  useEffect(() => {
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    setVisibleHICS(false);
  }, [vehiculo]);

  useEffect(() => {
    if (visibleHICS) {
      document.documentElement.style.overflowY = "hidden"; // Para <html>
      document.body.style.overflowY = "hidden"; // Para <body>
    } else {
      document.documentElement.style.overflowY = "auto";
      document.body.style.overflowY = "auto";
    }

    // Limpieza en caso de desmontar el componente
    return () => {
      document.documentElement.style.overflowY = "auto";
      document.body.style.overflowY = "auto";
    };
  }, [visibleHICS]);

  // Función para desplazar a la sección correspondiente
  const scrollToSection = (
    sectionRef: React.RefObject<HTMLDivElement>,
    menos: number
  ) => {
    if (sectionRef.current) {
      window.scrollTo({
        top: sectionRef.current.offsetTop - menos,
        behavior: "smooth",
      });
    }
  };

  const handleScroll = () => {
    const scrollPosition = window.scrollY;
    const offsets = [
      { id: "cotizacion", ref: cotizacionRef, menos: 230 },
      { id: "motor", ref: motorRef, menos: 50 },
      { id: "diseño", ref: diseñoRef, menos: 150 },
      { id: "versiones", ref: versionesRef, menos: 60 },
      { id: "galeria", ref: galeriaRef, menos: 100 },
      { id: "tecnologia", ref: tecnologiaRef, menos: 150 },
      { id: "modelos", ref: modelosRef, menos: 80 },
    ];

    for (const offset of offsets) {
      if (offset.ref.current) {
        const top = offset.ref.current.offsetTop - offset.menos;
        const height = offset.ref.current.offsetHeight;

        // Si el scroll está dentro de la sección
        if (scrollPosition >= top && scrollPosition < top + height) {
          setSelectedMenu(offset.id);
          break;
        }
      }
    }
  };

  // Manejar el cambio de URL para hacer scroll
  useEffect(() => {
    const hash = location.hash;
    if (hash === "#diseno") {
      scrollToSection(diseñoRef, 150);
    } else if (hash === "#cotizacion") {
      scrollToSection(cotizacionRef, 230);
    } else if (hash === "#motor") {
      scrollToSection(motorRef, 150);
    } else if (hash === "#versiones") {
      scrollToSection(versionesRef, 60);
    } else if (hash === "#galeria") {
      scrollToSection(galeriaRef, 100);
    } else if (hash === "#tecnologia") {
      scrollToSection(tecnologiaRef, 150);
    } else if (hash === "#modelos") {
      scrollToSection(modelosRef, 50);
    }
  }, [location]);

  // Renderizar condicionalmente basado en el estado de carga
  if (loading) {
    return <div></div>; // Puedes usar un spinner o un mensaje más estilizado
  }

  const CompararEvent = async (
    modelo: any,
    modelo2: any,
    version: any,
    version2: any
  ) => {
    try {
      const fileUrl =
        "https://s3-umbra-storage-cloud-v2.s3.us-east-1.amazonaws.com/strapi/COMPARADOR/2026_04_14_especificaciones_hyundai.xlsx"; // Reemplaza con tu URL

      // Descargar el archivo como arraybuffer
      const response = await axios.get(fileUrl, {
        responseType: "arraybuffer",
      });

      // Leer el archivo Excel
      const workbook = XLSX.read(new Uint8Array(response.data), {
        type: "array",
      });

      // Tomar la primera hoja
      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];

      // Procesar datos en formato JSON
      const sheetData: any[][] = XLSX.utils.sheet_to_json(worksheet, {
        header: 1,
      });

      /* console.log(modelo, modelo2, version, version2); */



      //const models: string[] = sheetData[3]// Encabezados desde la segunda fila
      const versionsFirts: any = sheetData[5].findIndex(
        (e: any) => e === dataVehicles.find((i: any) => i.slug === modelo && i.version === version)?.name
      );

      const versionsSecond: any = sheetData[5].findIndex(
        (e: any) =>
          e === dataVehicles.find((i: any) => i.slug === modelo2 && i.version === version2)?.name
      );

      //console.log(versionsFirts);
      //console.log(versionsSecond);

      let vehicles: any = [];

      // Consolas para depuración
      /* console.log(versionsFirts);
      console.log(versionsSecond); */


      // Iterar sobre las filas de datos
      for (let rowIndex = 2; rowIndex < sheetData.length; rowIndex++) {
        const row = sheetData[rowIndex];
        /* console.log(row); */


        //const vehicle: VehicleData = { name: row[0] }; // Nombre del vehículo

        const cellRef = XLSX.utils.encode_cell({ c: 1, r: rowIndex });
        //console.log(cellRef);

        const cell = worksheet[cellRef];
        //console.log(cell);

        if (grupos.find((e: any) => e === cell?.w)) {
          //console.log(row[0], row[1]);
          vehicles.push({ title: row[0], content: [] });
        } else {
          if (vehicles.length > 0) {
            const cellRefLabel = XLSX.utils.encode_cell({ c: 0, r: rowIndex });
            const cellRefFirts = XLSX.utils.encode_cell({
              c: versionsFirts,
              r: rowIndex,
            });
            const cellRefSecond = XLSX.utils.encode_cell({
              c: versionsSecond,
              r: rowIndex,
            });

            const cellLabel = worksheet[cellRefLabel];
            const cellFirts = worksheet[cellRefFirts];
            const cellSecond = worksheet[cellRefSecond];

            //console.log(cellLabel);
            //console.log(cellFirts);
            //console.log(cellSecond);
            if (cellLabel?.w !== "") {
              vehicles[vehicles.length - 1].content.push({
                label: cellLabel?.w,
                firts: versionsFirts === 0 ? "" : cellFirts?.w,
                second: versionsSecond === 0 ? "" : cellSecond?.w,
              });
              setActiveComparador(true);
            }
          }
        }
      }

      console.log(vehicles);

      setData(vehicles); // Actualizar estado con los datos procesados
    } catch (error) {
      console.error("Error al cargar o procesar el archivo:", error);
    }
  };

  const bannerSrc = (banner as any).src;
  const bannerSrcPortrait = (banner as any).srcPortrait || bannerSrc;
  const mobilePreload = bannerSrcPortrait ? getResponsiveImage(bannerSrcPortrait).mobile : '';
  const desktopPreload = bannerSrc ? getResponsiveImage(bannerSrc).desktop : '';

  return (
    <>
      <Helmet>
        {mobilePreload && (
          <link rel="preload" as="image" href={mobilePreload} media="(max-width: 768px)" fetchPriority="high" />
        )}
        {desktopPreload && (
          <link rel="preload" as="image" href={desktopPreload} media="(min-width: 769px)" fetchPriority="high" />
        )}
        <title>{`Hyundai ${(banner as any).title || ""} 2026 | Precio y Cotización Colombia`}</title>
        <meta
          name="description"
          content={`Conoce el nuevo Hyundai ${(banner as any).title || ""} 2026. Encuentra especificaciones técnicas, precio, versiones disponibles en Colombia y cotiza tu vehículo online.`}
        />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Car",
            "name": `Hyundai ${(banner as any).title || ""}`,
            "brand": {
              "@type": "Brand",
              "name": "Hyundai"
            },
            "description": `Hyundai ${(banner as any).title || ""} 2026 en Colombia - Especificaciones y precio.`,
            "offers": {
              "@type": "Offer",
              "priceCurrency": "COP",
              "price": (vehiculos as any).precio
                ? parseInt((vehiculos as any).precio.replace(/\$|,|\./g, ""))
                : undefined,
              "url": window.location.href
            }
          })}
        </script>
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [
              {
                "@type": "ListItem",
                "position": 1,
                "name": "Inicio",
                "item": window.location.origin
              },
              {
                "@type": "ListItem",
                "position": 2,
                "name": "Vehículos",
                "item": `${window.location.origin}/vehiculos`
              },
              {
                "@type": "ListItem",
                "position": 3,
                "name": (banner as any).title || "Detalle",
                "item": window.location.href
              }
            ]
          })}
        </script>
      </Helmet>
      <MenuLayouts
        className="home-page"
        active="vehiculo"
        setVisibleHeight={setVisibleHeight}
        visibleHeight={visibleHeight}
      />
      <div
        className="home-page"
        style={
          section === "comparador"
            ? { background: "#F6F3F2 0% 0% no-repeat padding-box" }
            : {}
        }
      >
        <div className="home-page-mascara"></div>
        <MenuVehiculosDetailComponent
          selectedMenu={selectedMenu}
          navigate={navigate}
          setSelectedMenu={setSelectedMenu}
          data={banner}
          visibleHeight={visibleHeight}
          ficha_tecnica={fichaTecnica}
          brochures={brochures}
          vehiculo={vehiculo}
          menus={{
            motor: engine?.engine?.gallery?.length > 0,
            galeria: galeria?.media[0] !== undefined,
            tecnologia: tecnologias?.tecnologia?.length > 0,
            modelos: versiones?.version?.length > 0,
            version: modelos?.modelos?.length > 0,
            comparador: modelos?.comparador?.length > 0,
          }}
          topbar_design={topbar_design}
          topbar_gallery={topbar_gallery}
          topbar_models={topbar_models}
          topbar_technology={topbar_technology}
          topbar_version={topbar_version}
          currentSection={currentSection}
        />
        {section === "comparador" ? (
          <>
            <TitleComponent />
            <div
              className={`overflow-container ${activeComparador ? "active" : ""
                }`}
            >
              <SeleccionComponent
                vehiculo={vehiculo}
                CompararEvent={CompararEvent}
                setActiveComparador={setActiveComparador}
                activeComparador={activeComparador}
              />
              <AcordeonComponent
                datos={data}
                activeComparador={activeComparador}
              />
            </div>
          </>
        ) : (
          <>
            <BannerVehiculosComponent
              banner={banner}
              setVisibleHICS={setVisibleHICS}
              visibleHICS={visibleHICS}
            />
            {visibleHICS ? (
              <HICSVehiculosComponent
                banner={HICS}
                setVisibleHICS={setVisibleHICS}
                visibleHICS={visibleHICS}
              />
            ) : null}
            <CotizacionVehiculosComponent
              vehiculo={vehiculos}
              ref={cotizacionRef}
            />
            {engine?.engine?.gallery?.length > 0 && (<MotorVehiculosComponent
              motores={engine}
              ref={motorRef}
            />)}
            <DiseñoVehiculosComponent diseño={diseño} ref={diseñoRef} />
            <ModelosVehiculosComponent
              modelos={modelos}
              ref={versionesRef}
              reserva={urlComparador}
            />
            {galeria?.media[0] !== undefined ? (
              <GaleriaVehiculosComponent
                selectedGalery={selectedGalery}
                setSelectedGalery={setSelectedGalery}
                galeria={galeria}
                ref={galeriaRef}
              />
            ) : null}
            <GaleriaModalVehiculosComponent
              selectedGalery={selectedGalery}
              setSelectedGalery={setSelectedGalery}
              galeria={galeria}
            />
            <CaracteristicasVehiculosComponent
              caracteristicas={caracteristicas}
            />
            {tecnologias?.tecnologia?.length > 0 ? (
              <TecnologiaVehiculosComponent
                tecnologias={tecnologias}
                ref={tecnologiaRef}
              />
            ) : null}
            {versiones?.version?.length > 0 ? (
              <VersionesVehiculosComponent
                versiones={versiones}
                ref={modelosRef}
              />
            ) : null}
            {reserva && reserva.length > 0 ? (
              <ReservaVehiculosComponent
                vehiculo={vehiculos}
                reserva={reserva}
              />
            ) : null}
            {comunidad && comunidad.length > 0 ? (
              <ComunidadVehiculosComponent
                comunidad={comunidad}
                handleOpenModal={handleOpenModal}
              />
            ) : null}

            <ModalComunidadHyundaiComponent
              isOpen={isModalOpen}
              onClose={handleCloseModal}
            >
              <ContenidoComunidadHyundaiComponent comunidad={comunidad} />
            </ModalComunidadHyundaiComponent>
          </>
        )}

        <OtrosVehiculosDinamicoComponent opportunities={opportunities} />
      </div>
      <BtnFloatingLayout reserva="https://reservas.hyundaicolombia.co/" />
      <FooterLayouts />
    </>
  );
};

export default VehiculosDetailPage;